import React from "react"
import { Link } from "react-router-dom"
import PageHeader from "../../components/DashboardComponents/PageHeader"

const PrivacyPolicy = () => (
  <div className="page-content">
    <div className="legal-portal">
      <PageHeader
        className="legal-portal__header"
        title="Privacy Policy"
        subtitle="How Amok Earth collects, uses, and protects your information."
      />

      <div className="legal-portal__content">
      <p className="legal-portal__updated">Last updated: August 22, 2026</p>

      <p>
        This Privacy Policy explains how Amok Earth (&quot;Amok Earth,&quot;
        &quot;we,&quot; &quot;us,&quot; or &quot;our&quot;) collects, uses, and
        shares information when you use our websites, apps, and related services
        (the &quot;Services&quot;).
      </p>

      <h2>1. Information we collect</h2>
      <p>We may collect:</p>
      <ul>
        <li>
          <strong>Account information</strong> — name, email address, password,
          profile details, and invite-related data you provide.
        </li>
        <li>
          <strong>Profile &amp; creative activity</strong> — roles, projects,
          sessions, collaborators, media you upload, and content you post in the
          Services.
        </li>
        <li>
          <strong>Usage data</strong> — device, browser, IP address, pages
          viewed, and interactions that help us operate and improve the
          platform.
        </li>
        <li>
          <strong>Communications</strong> — messages you send to us or through
          in-product messaging features.
        </li>
      </ul>

      <h2>2. How we use information</h2>
      <p>We use information to:</p>
      <ul>
        <li>Provide, maintain, and improve the Services</li>
        <li>Authenticate users and protect accounts and communities</li>
        <li>Enable collaboration, projects, sessions, and city hub features</li>
        <li>Send service-related notices and respond to support requests</li>
        <li>Analyze usage to improve performance and product design</li>
        <li>Comply with law and enforce our Terms &amp; Conditions</li>
      </ul>

      <h2>3. How we share information</h2>
      <p>
        We do not sell your personal information. We may share information with:
      </p>
      <ul>
        <li>
          Other users according to your profile and project visibility settings
        </li>
        <li>
          Service providers who help us host, operate, and secure the Services
        </li>
        <li>
          Authorities when required by law or to protect rights, safety, and
          integrity
        </li>
        <li>
          Successors in connection with a merger, acquisition, or asset transfer
        </li>
      </ul>

      <h2>4. Cookies and similar technologies</h2>
      <p>
        We may use cookies and similar technologies for authentication,
        preferences, security, and analytics. You can control cookies through
        your browser settings, but some features may not work without them.
      </p>

      <h2>5. Data retention</h2>
      <p>
        We retain information as long as needed to provide the Services, meet
        legal obligations, resolve disputes, and enforce agreements. You may
        request deletion of your account subject to applicable law and
        legitimate retention needs.
      </p>

      <h2>6. Security</h2>
      <p>
        We use reasonable administrative, technical, and organizational measures
        to protect information. No method of transmission or storage is
        completely secure, and we cannot guarantee absolute security.
      </p>

      <h2>7. Your choices</h2>
      <ul>
        <li>Update profile and account information in the Services</li>
        <li>Manage notifications and visibility settings where available</li>
        <li>
          Contact us to request access, correction, or deletion of personal data
        </li>
      </ul>

      <h2>8. Children</h2>
      <p>
        The Services are not directed to children under 13 (or the minimum age
        required in your jurisdiction). We do not knowingly collect personal
        information from children.
      </p>

      <h2>9. Changes</h2>
      <p>
        We may update this Privacy Policy from time to time. We will post the
        updated version on this page and revise the &quot;Last updated&quot;
        date. Continued use of the Services after changes means you accept the
        updated policy.
      </p>

      <h2>10. Contact</h2>
      <p>
        Questions about this Privacy Policy or our privacy practices can be sent
        through the support channels available in the Amok Earth product.
      </p>

      <p className="legal-portal__crosslink">
        See also our{" "}
        <Link to="/terms-of-service">Terms &amp; Conditions</Link>.
      </p>
      </div>
    </div>
  </div>
)

export default PrivacyPolicy
